import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Paragraph, Skeleton } from '@digdir/designsystemet-react';
import layout from '../../HRDashboard/hmsPage.module.css';
import classes from '../SafetyRep.module.css';

/** While the page loads, or when it could not */
export const WorkState = ({
  loading,
  error,
}: {
  loading: boolean;
  error: string;
}): ReactElement => {
  const { t } = useTranslation();
  return loading ? (
    <div aria-busy="true" className={layout.loading}>
      <span className="ds-sr-only">{t('safetyRep.loading')}</span>
      <Skeleton variant="rectangle" width="100%" height={260} />
    </div>
  ) : (
    <div className={classes.column}>
      <Alert data-color="danger">
        <Paragraph>{error}</Paragraph>
      </Alert>
    </div>
  );
};
